import { Box, Button, CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import TableRows from "./detailsRows/tableRows"
import OrderAndAccountInfo from "./detailsRows/orderAndAccountInfo"
import OrderedProducts from "./detailsRows/orderedProducts"
import { useQuery } from "@tanstack/react-query"
import { userApi } from "api/user/user"
import { orderApi } from "api/orders/orders"
import AdressInfo from "./detailsRows/adressInfo"
import { useNavigate, useParams } from "react-router-dom"
import ExpandCircleDownRoundedIcon from '@mui/icons-material/ExpandCircleDownRounded';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const OrderDetails = () => {
    const { orderId } = useParams();
    const Navigate = useNavigate();
    const { data: order, isError: orderError, isLoading: orderLoader } = useQuery({
        queryKey: ["order", orderId],
        queryFn: () => orderApi.getOrderDetails(orderId),
        enabled: !!orderId,  
    });

    if (orderLoader) {
        return (
            <Box sx={{width : 1 , height : "90vh" , display : "flex" , justifyContent : "center" , alignItems : "center"}}>
                <CircularProgress sx={{ color: "gray" }} size={"50px"} />
            </Box>
        );
    }
    return (
        <Box>
            <Box px={1} py={2} display={"flex"} alignItems={"center"} mb={1} bgcolor={"#686868"} sx={{ position: 'fixed', top: "60px", width: '100%', zIndex: 1 }} >
            <Button m={0} p={0} sx={{color : "white" , padding:0}} onClick={() => Navigate('/orders')}>
            <ArrowBackIcon />
                </Button>
                <Typography sx={{ fontWeight: 500 , color : "white"}}>
                Ordre oversigt
                </Typography>
                
            </Box>
            <Box p={2} marginTop={"60px"}>
            <OrderAndAccountInfo order_={order.data} />
            <AdressInfo order={order.data} />
            <OrderedProducts order_={order.data} />
            </Box>
        </Box>
    )
}

export default OrderDetails